import { useNavigate } from "@solidjs/router";
import { useI18n } from "@/api/i18n";
import { JobOfferSuccessLayout } from "@/components/shared/JobOfferSuccessLayout";
import { MetaTitleWithSeparator } from "@/domains/business/seo";
import { useGetJobOfferV2 } from "@/domains/job-offer/api";
import { RemotePolicy } from "@/domains/job-offer/create/constants";

export default function SuccessRoute() {
  const navigate = useNavigate();

  const jobOfferId = localStorage.getItem("created_job_offer_id");
  const jobOfferQuery = useGetJobOfferV2(jobOfferId || "");

  const handleGoToATS = () => {
    if (jobOfferId) {
      localStorage.removeItem("created_job_offer_id");
      navigate(`/profile/company/ats/${jobOfferId}`);
    } else {
      navigate("/profile/company/ats");
    }
  };

  const handleMakeDonation = () => {
    // External donation link - replace with actual donation URL
    window.open(import.meta.env.VITE_PUBLIC_DONATION_URL, "_blank");
  };

  const handleShareLinkedIn = () => {
    if (!jobOfferId) return;
    const publicLink = `${window.location.origin}/?job=${encodeURIComponent(jobOfferId)}`;
    const title = jobOfferQuery.data?.job_offer?.title;
    const company = jobOfferQuery.data?.job_offer?.company_id?.name;
    const description = jobOfferQuery.data?.job_offer?.description;
    const remotePolicy = jobOfferQuery.data?.job_offer?.remote_policy;
    const location = jobOfferQuery.data?.job_offer?.location;
    const startDate = jobOfferQuery.data?.job_offer?.start_date;
    const experienceLevel = jobOfferQuery.data?.job_offer?.experience_level;
    const duration = jobOfferQuery.data?.job_offer?.duration;
    // Remove HTML tags from description
    const cleanDescription = description
      ?.replace(/<[^>]*>?/g, "")
      .replace("&nbsp;", "\n")
      .trim();

    let baseText = "";
    if (title && company) {
      baseText = `${title} @ ${company}`;
    } else if (title) {
      baseText = title;
    } else {
      baseText = "Nuova job offer su SeVedemo";
    }

    if (description) {
      baseText += `\n\n${cleanDescription}`;
    }

    if (remotePolicy === RemotePolicy.REMOTE) {
      baseText += `\n\nModalità remota`;
    } else if (remotePolicy === RemotePolicy.ONSITE) {
      baseText += `\n\nModalità presenziale`;
    } else if (remotePolicy === RemotePolicy.HYBRID) {
      baseText += `\n\nModalità ibrida`;
    }

    if (location) {
      baseText += `\nLocation: ${location.join(", ")}`;
    }
    if (startDate) {
      baseText += `\nData inizio: ${t(`common.start_date_options.${startDate}`)}`;
    }
    if (duration) {
      baseText += `\nDurata: ${t(`common.duration_options.${duration}`)}`;
    }
    if (experienceLevel) {
      baseText += `\nLivello esperienza: ${t(`common.experience_level_options.${experienceLevel}`)}`;
    }

    baseText += `\n\nVedi l'annuncio: ${publicLink}`;

    const shareUrl = `https://www.linkedin.com/feed/?shareActive=true&shareUrl=${encodeURIComponent(publicLink)}&text=${encodeURIComponent(baseText)}`;
    window.open(shareUrl, "_blank", "noopener");
  };

  const { t } = useI18n();

  return (
    <>
      <MetaTitleWithSeparator>
        {t("jobOffers.create.success.title")}
      </MetaTitleWithSeparator>

      <JobOfferSuccessLayout
        onGoToATS={handleGoToATS}
        onMakeDonation={handleMakeDonation}
        onShareLinkedIn={handleShareLinkedIn}
      />
    </>
  );
}
